import React, { Component } from "react";
import logo from "../img/rat-logo.png";
import $ from "jquery";
import Script from "react-load-script";
import Helmet from "react-helmet";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  browserHistory,
} from "react-router-dom";
var GifPlayer = require("react-gif-player");

class Home extends Component {
  componentDidMount() {
    $("body").bind("touchmove", function (event) {
      event.preventDefault();
    });
    autoPlayYouTubeModal();

    //FUNCTION TO GET AND AUTO PLAY YOUTUBE VIDEO FROM DATATAG
    function autoPlayYouTubeModal() {
      var trigger = $("body").find('[data-toggle="modal"]');
      trigger.click(function () {
        var theModal = $(this).data("target"),
          videoSRC = $(this).attr("data-thevideo"),
          videoSRCauto = videoSRC + "?autoplay=1";
        $(theModal + " iframe").attr("src", videoSRCauto);
        $(theModal + " button.close").click(function () {
          $(theModal + " iframe").attr("src", videoSRC);
        });
        $(".modal").click(function () {
          $(theModal + " iframe").attr("src", videoSRC);
        });
      });
    }

    onloadYoutubePlay();
    function onloadYoutubePlay() {
      var theModal = "#videoModal",
        videoSRC = "https://www.youtube.com/embed/watch?v=MbAvLcq6_SI",
        videoSRCauto = videoSRC + "?autoplay=1";
      $(theModal + " iframe").attr("src", videoSRCauto);
      $(theModal + " button.close").click(function () {
        $(theModal + " iframe").attr("src", videoSRC);
      });
      $(".modal").click(function () {
        $(theModal + " iframe").attr("src", videoSRC);
      });
    }

    $(".thumb-item")
      .mouseover(function () {
        $(this)
          .find(".thumb-img")
          .attr("src", $(this).find(".thumb-img").data("hover"));
      })
      .mouseout(function () {
        $(this)
          .find(".thumb-img")
          .attr("src", $(this).find(".thumb-img").data("src"));
      });
  }

  render() {
    return (
      <div>
        <Helmet
          title="RAT Films - Best Film Production Company in India"
          meta={[
            {
              name: "description",
              content:
                "RAT Films came into existence because of its commitment to deliver cutting-edge films with the hallmark of quality and film-making passion.    ",
            },
          ]}
        />
        <div className="main-content">
          <section className="portfolio">
            <div className="container thumb-cont">
              {/* new datas */}
              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/538105209"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Hunk-@-Theatre thumbnail.png")}
                  data-src={require("../img/Hunk-@-Theatre thumbnail.png")}
                  data-hover={require("../img/Hunk-@-Theatre.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Hunk @ Theatre</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/538102928"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Gourmet-By-Vadilal thumbnail.png")}
                  data-src={require("../img/Gourmet-By-Vadilal thumbnail.png")}
                  data-hover={require("../img/Gourmet-By-Vadilal.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Gourmet By Vadilal</h2>
                    </div>
                  </div>
                </div>
              </div>


              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/520815980"
              >
                <img
                  className="thumb-img"
                  src={require("../img/DIVIDE.png")}
                  data-src={require("../img/DIVIDE.png")}
                  data-hover={require("../img/DIVIDE.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        The divide, a social Experiment.{" "}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/521257091"
              >
                <img
                  className="thumb-img"
                  src={require("../img/FENA.png")}
                  data-src={require("../img/FENA.png")}
                  data-hover={require("../img/FENA.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">FENA</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/538103429"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Matka-Kulfi-By-Vadilal thumbnail.png")}
                  data-src={require("../img/Matka-Kulfi-By-Vadilal thumbnail.png")}
                  data-hover={require("../img/Matka-Kulfi-By-Vadilal.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Matka Kulfi By Vadilal
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/538103837"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Office-Intern thumbnail.png")}
                  data-src={require("../img/Office-Intern thumbnail.png")}
                  data-hover={require("../img/Office-Intern.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Office Intern</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/538104280"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Birthday-Party-thumbnail.png")}
                  data-src={require("../img/Birthday-Party-thumbnail.png")}
                  data-hover={require("../img/Birthday-Party.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Birthday Party</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/521252910"
              >
                <img
                  className="thumb-img"
                  src={require("../img/HUNDRED.png")}
                  data-src={require("../img/HUNDRED.png")}
                  data-hover={require("../img/HUNDRED.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Hundred Trailer</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/538104749"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Proposal thumbnail.png")}
                  data-src={require("../img/Proposal thumbnail.png")}
                  data-hover={require("../img/Proposal.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Proposal</h2>
                    </div>
                  </div>
                </div>
              </div>
              
              

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/334713654"
              >
                <img
                  className="thumb-img"
                  src={require("../img/JK-TYRE.png")}
                  data-src={require("../img/JK-TYRE.png")}
                  data-hover={require("../img/JK-TYRE.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">JK TYRE</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/333499921"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Daddy-No1.png")}
                  data-src={require("../img/Daddy-No1.png")}
                  data-hover={require("../img/Daddy-No1.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Daddy No1</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/333499420"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Jugalbandi.png")}
                  data-src={require("../img/Jugalbandi.png")}
                  data-hover={require("../img/Jugalbandi.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Jugalbandi</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/330038024"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Becoming-a-Father.png")}
                  data-src={require("../img/Becoming-a-Father.png")}
                  data-hover={require("../img/Becoming-a-Father.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Becoming a Father</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/330037191"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Small-Scale-Development.png")}
                  data-src={require("../img/Small-Scale-Development.png")}
                  data-hover={require("../img/Small-Scale-Development.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Small Scale Development
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/330036411"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Innovative-Friend.png")}
                  data-src={require("../img/Innovative-Friend.png")}
                  data-hover={require("../img/Innovative-Friend.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Innovative Friend</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/330035722"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Smart-Investment.png")}
                  data-src={require("../img/Smart-Investment.png")}
                  data-hover={require("../img/Smart-Investment.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Smart Investment</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/330035213"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Gold.png")}
                  data-src={require("../img/Gold.png")}
                  data-hover={require("../img/Gold.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Gold</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/330034963"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Cafe.png")}
                  data-src={require("../img/Cafe.png")}
                  data-hover={require("../img/Cafe.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Cafe</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/291668169"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Son in Law 3.jpg")}
                  data-src={require("../img/Son in Law 3.jpg")}
                  data-hover={require("../img/soninlaw.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Son in Law</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/291667867"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Rain 4.jpg")}
                  data-src={require("../img/Rain 4.jpg")}
                  data-hover={require("../img/rain.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Rain</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290685570"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Mental 2.jpg")}
                  data-src={require("../img/Mental 2.jpg")}
                  data-hover={require("../img/mental.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Mental</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290687102"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Pappa Di Gaddi 2.jpg")}
                  data-src={require("../img/Pappa Di Gaddi 2.jpg")}
                  data-hover={require("../img/pappadi.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        HYM - Pappa Di Gaddi{" "}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/280706890"
              >
                <img
                  className="thumb-img"
                  src={require("../img/brezza.jpg")}
                  data-src={require("../img/brezza.jpg")}
                  data-hover={require("../img/maruti suzuki brezza.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Maruti Suzuki Vitara Brezza
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275638020"
              >
                <img
                  className="thumb-img"
                  src={require("../img/icreate.jpg")}
                  data-src={require("../img/icreate.jpg")}
                  data-hover={require("../img/Swift iCreate.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Swift iCreate</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/281252390"
              >
                <img
                  className="thumb-img"
                  src={require("../img/brezza-product.jpg")}
                  data-src={require("../img/brezza-product.jpg")}
                  data-hover={require("../img/maruti suzuki brezza.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Brezza Product Film
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/276706925"
              >
                <img
                  className="thumb-img"
                  src={require("../img/general-airflow.jpg")}
                  data-src={require("../img/general-airflow.jpg")}
                  data-hover={require("../img/GENERAL AIRFLOW.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">General</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275618855"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_13.jpg")}
                  data-src={require("../img/pf_item_13.jpg")}
                  data-hover={require("../img/relaxo.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Relaxo - Salman</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275596972"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_43.jpg")}
                  data-src={require("../img/pf_item_43.jpg")}
                  data-hover={require("../img/royal estate.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Royal Estate - SRK</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275383393"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_45.jpg")}
                  data-src={require("../img/pf_item_45.jpg")}
                  data-hover={require("../img/omron.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Omron - Farhan</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/278667113"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_11.jpg")}
                  data-src={require("../img/pf_item_11.jpg")}
                  data-hover={require("../img/vestar.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Vestar - Irrfan </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5315742/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/vadilalfriendzoned.jpg")}
                  data-src={require("../img/vadilalfriendzoned.jpg")}
                  data-hover={require("../img/VADILAL Friendzoned.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Vadilal </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5315743/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/vadilal-embarressed.jpg")}
                  data-src={require("../img/vadilal-embarressed.jpg")}
                  data-hover={require("../img/Vadilal Embarrassed TVC.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Vadilal </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5315745/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/SNICKERS CONFUSED 2.jpg")}
                  data-src={require("../img/SNICKERS CONFUSED 2.jpg")}
                  data-hover={require("../img/snickers tubelight.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Snickers</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/294744410"
              >
                <img
                  className="thumb-img"
                  src={require("../img/adda 52.jpg")}
                  data-src={require("../img/adda 52.jpg")}
                  data-hover={require("../img/adda52.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Adda 52</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290691005"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Tall Man 5.jpg")}
                  data-src={require("../img/Tall Man 5.jpg")}
                  data-hover={require("../img/tallman.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Tall Man</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290689466"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Road Trip 3.jpg")}
                  data-src={require("../img/Road Trip 3.jpg")}
                  data-hover={require("../img/roadtrip.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Road Trip</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290687865"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Promise 2.jpg")}
                  data-src={require("../img/Promise 2.jpg")}
                  data-hover={require("../img/promise.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Promise</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/291681025"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Birthday 1.png")}
                  data-src={require("../img/Birthday 1.png")}
                  data-hover={require("../img/birthday.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Birthday</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290693752"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Zid 1.jpg")}
                  data-src={require("../img/Zid 1.jpg")}
                  data-hover={require("../img/zid.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Zid</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/290686543"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Mumbai Floods 5.jpg")}
                  data-src={require("../img/Mumbai Floods 5.jpg")}
                  data-hover={require("../img/mumbaiflood.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">HYM - Floods</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5488138/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/1 Hyundai Naamkaran.jpg")}
                  data-src={require("../img/1 Hyundai Naamkaran.jpg")}
                  data-hover={require("../img/Panditji.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Hyundai Naamkaran</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5315749/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_1.jpg")}
                  data-src={require("../img/pf_item_1.jpg")}
                  data-hover={require("../img/snicker-ad.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Snickers</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/278664507"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_44.jpg")}
                  data-src={require("../img/pf_item_44.jpg")}
                  data-hover={require("../img/sniker_veerappan.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Snickers Veerappan</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275627399"
              >
                <img
                  className="thumb-img"
                  src={require("../img/beti-film-70.jpg")}
                  data-src={require("../img/beti-film-70.jpg")}
                  data-hover={require("../img/Somany_Bath_Fittings_2016_Bathroom_of_your_Dreams.gif")}
                  alt=""
                />

                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Somany</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275625448"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Capture.jpg")}
                  data-src={require("../img/Capture.jpg")}
                  data-hover={require("../img/somany.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Somany Beti Film</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5315751/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_6.jpg")}
                  data-src={require("../img/pf_item_6.jpg")}
                  data-hover={require("../img/lloyd washing machine.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Lloyd Unisex</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/278664351"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_48.jpg")}
                  data-src={require("../img/pf_item_48.jpg")}
                  data-hover={require("../img/magic bricks chice.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Magic Bricks Choice{" "}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/278666438"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_8.jpg")}
                  data-src={require("../img/pf_item_8.jpg")}
                  data-hover={require("../img/Magic bricks squirell.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Magic Bricks - Squirrel
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/278666788"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Magic Bricks Bird Tree House1.jpg")}
                  data-src={require("../img/Magic Bricks Bird Tree House1.jpg")}
                  data-hover={require("../img/magic bricks _tree house.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Magic Bricks bird House
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275594220"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_5.jpg")}
                  data-src={require("../img/pf_item_5.jpg")}
                  data-hover={require("../img/Magic bricks.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Magic Bricks</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275601276"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_47.jpg")}
                  data-src={require("../img/pf_item_47.jpg")}
                  data-hover={require("../img/lloyd.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">LLOYD</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275595412"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_46.jpg")}
                  data-src={require("../img/pf_item_46.jpg")}
                  data-hover={require("../img/lloyd led tv.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">LLOYD Led TV</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275594863"
              >
                <img
                  className="thumb-img"
                  src={require("../img/nido1.jpg")}
                  data-src={require("../img/nido1.jpg")}
                  data-hover={require("../img/NIDO.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Nido</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275609746"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_42.jpg")}
                  data-src={require("../img/pf_item_42.jpg")}
                  data-hover={require("../img/freedom oil.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Freedom Oil</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275612895"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_10.jpg")}
                  data-src={require("../img/pf_item_10.jpg")}
                  data-hover={require("../img/max health care.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Max Health Care</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/281262645"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_9.jpg")}
                  data-src={require("../img/pf_item_9.jpg")}
                  data-hover={require("../img/Balakrishna.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Retrospective Film On Balkrishna Doshi
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275381348"
              >
                <img
                  className="thumb-img"
                  src={require("../img/magic-bus-ngo-film.jpg")}
                  data-src={require("../img/magic-bus-ngo-film.jpg")}
                  data-hover={require("../img/magic bus ngo film.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Magic Bus NGO film</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275590716"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Immunization-Music-Video.jpg")}
                  data-src={require("../img/Immunization-Music-Video.jpg")}
                  data-hover={require("../img/immunization.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Immunization Music Video
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275251247"
              >
                <img
                  className="thumb-img"
                  src={require("../img/National Literacy - Forest Film1.jpg")}
                  data-src={require("../img/National Literacy - Forest Film1.jpg")}
                  data-hover={require("../img/national literacy mission.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        National Literacy Mission-Forest Film
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275383595"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_35.jpg")}
                  data-src={require("../img/pf_item_35.jpg")}
                  data-hover={require("../img/literacy mission_accident.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        National Literacy Mission-Accident
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275603070"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_34.jpg")}
                  data-src={require("../img/pf_item_34.jpg")}
                  data-hover={require("../img/literacy mission_fishermen.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        National Literacy Mission-FisherMan
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275380666"
              >
                <img
                  className="thumb-img"
                  src={require("../img/shiksha ka suraj1.jpg")}
                  data-src={require("../img/shiksha ka suraj1.jpg")}
                  data-hover={require("../img/shiksha ka suraj.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Shiksha Ka Suraj</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo=" https://player.vimeo.com/video/281259952"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Kelloggs Blue Socks1st.jpg")}
                  data-src={require("../img/Kelloggs Blue Socks1st.jpg")}
                  data-hover={require("../img/kelloggs-socks.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Kellogg’s All Bran (Socks)
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275383499"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_21.jpg")}
                  data-src={require("../img/pf_item_21.jpg")}
                  data-hover={require("../img/complan.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Kelloggs</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275587610"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_39.jpg")}
                  data-src={require("../img/pf_item_39.jpg")}
                  data-hover={require("../img/kelloggs choco.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Kellogg’s Chocos Chota Pack
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275244851"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Kelloggs All Bran Mechanic.jpg")}
                  data-src={require("../img/Kelloggs All Bran Mechanic.jpg")}
                  data-hover={require("../img/kelloggs all bran.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Kelloggs All Bran</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/127156063"
              >
                <img
                  className="thumb-img"
                  src={require("../img/bigg boss parrot1.jpg")}
                  data-src={require("../img/bigg boss parrot1.jpg")}
                  data-hover={require("../img/bigboss parrot.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Big Boss Parrot</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275607340"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_36.jpg")}
                  data-src={require("../img/pf_item_36.jpg")}
                  data-hover={require("../img/panic room_bigboss.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        The Panic Room - Bigg Boss 6
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275384878"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_16.jpg")}
                  data-src={require("../img/pf_item_16.jpg")}
                  data-hover={require("../img/bodyguard_kareena.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Bodyguard-Kareena Kapoor Khan Intro
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://vimeo.com/album/5315753/embed"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_38.jpg")}
                  data-src={require("../img/pf_item_38.jpg")}
                  data-hover={require("../img/himalaya.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Himalaya Anti Dandruff Shampo
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275593715"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_32.jpg")}
                  data-src={require("../img/pf_item_32.jpg")}
                  data-hover={require("../img/pedia sure complete.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Pedia Sure Complete
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275634004"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_41.jpg")}
                  data-src={require("../img/pf_item_41.jpg")}
                  data-hover={require("../img/baby shop.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Baby Shop</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275594362"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_31.jpg")}
                  data-src={require("../img/pf_item_31.jpg")}
                  data-hover={require("../img/lic child plan.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">LIC-Basketball</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/281268768"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_14.jpg")}
                  data-src={require("../img/pf_item_14.jpg")}
                  data-hover={require("../img/lic childrens plan.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        LIC Children’s Plan
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275245586"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_24.jpg")}
                  data-src={require("../img/pf_item_24.jpg")}
                  data-hover={require("../img/colgate.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Colgate</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275597550"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_28.jpg")}
                  data-src={require("../img/pf_item_28.jpg")}
                  data-hover={require("../img/colgate pro_gum.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Colgate 30 SEC HIN</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275606911"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_26.jpg")}
                  data-src={require("../img/pf_item_26.jpg")}
                  data-hover={require("../img/ariel matic.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Ariel Matic</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/278793691"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_27.jpg")}
                  data-src={require("../img/pf_item_27.jpg")}
                  data-hover={require("../img/goodrej range.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Godrej</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275594709"
              >
                <img
                  className="thumb-img"
                  src={require("../img/vgn builders ice cream1.jpg")}
                  data-src={require("../img/vgn builders ice cream1.jpg")}
                  data-hover={require("../img/VGN Builders-Ice Cream.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        VGN Builders-Ice Cream
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275600661"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_20.jpg")}
                  data-src={require("../img/pf_item_20.jpg")}
                  data-hover={require("../img/VGN builders.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">VGN Builders-Tent</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275602339"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_23.jpg")}
                  data-src={require("../img/pf_item_23.jpg")}
                  data-hover={require("../img/VGN hazel rush.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">VGN Hazel Rush</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275595323"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_22.jpg")}
                  data-src={require("../img/pf_item_22.jpg")}
                  data-hover={require("../img/magic bricks_ipl campaign.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Magic Bricks IPL campaign
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275596288"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_19.jpg")}
                  data-src={require("../img/pf_item_19.jpg")}
                  data-hover={require("../img/cream soda_elephant house.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Elephant House Cream Soda TVC
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275595535"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_18.jpg")}
                  data-src={require("../img/pf_item_18.jpg")}
                  data-hover={require("../img/philips.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Phillips</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/281260902"
              >
                <img
                  className="thumb-img"
                  src={require("../img/Airy-Updo.jpg")}
                  data-src={require("../img/Airy-Updo.jpg")}
                  data-hover={require("../img/Airy Updo.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">
                        Tresemme Red Carpet Ready- Airy Updo
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-3 thumb-item play-video"
                href="#"
                data-toggle="modal"
                data-target="#videoModal"
                data-theVideo="https://player.vimeo.com/video/275247016"
              >
                <img
                  className="thumb-img"
                  src={require("../img/pf_item_17.jpg")}
                  data-src={require("../img/pf_item_17.jpg")}
                  data-hover={require("../img/complan1.gif")}
                  alt=""
                />
                <div className="overlay">
                  <div className="overlay-inner">
                    <div className="play-icon">
                      <img src={require("../img/play.png")} alt="" />
                    </div>
                    <div className="video-label">
                      <h2 className="ft-white link-text">Complan</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div
          className="modal fade"
          id="videoModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="videoModal"
          aria-hidden="true"
          data-dismiss="modal"
        >
          <div
            className="vertical-align"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <div className="modal-dialog vertical-align-center">
              <div className="modal-content modal-content-bg">
                <div className="modal-body">
                  <a
                    href="#"
                    className="close-video"
                    data-dismiss="modal"
                    aria-hidden="true"
                  >
                    <img src={require("../img/close.png")} />
                  </a>
                  <div>
                    <div className="embed-responsive embed-responsive-4by3">
                      <iframe
                        className="embed-responsive-item"
                        src="your_page_url"
                        allowfullscreen="allowfullscreen"
                        mozallowfullscreen="mozallowfullscreen"
                        msallowfullscreen="msallowfullscreen"
                        oallowfullscreen="oallowfullscreen"
                        webkitallowfullscreen="webkitallowfullscreen"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home.js